import { AlertActionTypes } from 'util/modules/Alert/redux/types'
/**
* Data Types
*/

export enum DocType { PP = 'PP', DL = 'DL', ID = 'ID', TIN = 'TIN', BIN = 'BIN', EIN = 'EIN' }

export interface Document {
  id: number,
  isMain: boolean,
  type: DocType,
  value: string,
  person: number,
  country: string,
  isValidated: boolean,
  createdAt: string,
  updatedAt?: string
}

/**
* State Type
*/

export interface DocumentState {
  readonly document?: Document
  readonly documents: Document[]
}

/**
* Action Data
*/

export interface DocumentData {
  type: string,
  value: string
}

/**
* Action Enum Types
*/

export enum DocumentTypes {
  DOCUMENT_CREATE = 'DOCUMENT/CREATE',
  DOCUMENT_UPDATE = 'DOCUMENT/UPDATE',
  DOCUMENT_DELETE = 'DOCUMENT/DELETE',
  DOCUMENT_GET = 'DOCUMENT/GET',
  DOCUMENT_GET_LIST = 'DOCUMENT/GET/LIST',
}

/**
* Action Types
*/
interface CreateAction {
  type: typeof DocumentTypes.DOCUMENT_CREATE,
  payload: Document
}

interface UpdatetAction {
  type: typeof DocumentTypes.DOCUMENT_UPDATE,
  payload: Document
}

interface DeleteAction {
  type: typeof DocumentTypes.DOCUMENT_DELETE,
  payload: number
}

interface GetAction {
  type: typeof DocumentTypes.DOCUMENT_GET,
  payload: Document
}

interface GetListAction {
  type: typeof DocumentTypes.DOCUMENT_GET_LIST,
  payload: Document[]
}

export type DocumentActionTypes = (
  AlertActionTypes | CreateAction | UpdatetAction | DeleteAction | GetAction | GetListAction
)
